import { Button } from '@codegouvfr/react-dsfr/Button';
import { useTextes } from '@common/config';
import { useOfaStatut } from '@common/hooks/organisme';
import {
  EtablissementDeclarantDto,
  OrganismeStatutType,
  StatutDeclaration,
  useGetAllOrganismeEtablissementsDeclarantsQuery,
} from '@common/services';
import { getModalById } from '@common/ui';
import React from 'react';
import { MdOutlineFileDownload } from 'react-icons/md';
import { DepotAttestationModal } from './modals/DepotAttestationModal';
import { DepotDeclarationModal } from './modals/DepotDeclarationModal';

const depotDeclarationModal = getModalById('depot-declaration-modal');
const depotAttestationModal = getModalById('depot-attestation-modal');

export const CampagneDepots = ({ campagneAnnee, organismeId }: CampagneDepotsProps) => {
  const t = useTextes('ParcoursOfa', 'Campagne');

  const { statut, isLoading: isStatutLoading } = useOfaStatut({ id: organismeId });

  const { data: etablissementsDeclarants = [] as EtablissementDeclarantDto[] } = useGetAllOrganismeEtablissementsDeclarantsQuery(
    { id: organismeId },
    { skip: !organismeId },
  );

  if (isStatutLoading) return null;

  const etablissementsWithDownloadedDeclaration = etablissementsDeclarants.filter(({ statutDeclaration }) => (statutDeclaration && statutDeclaration !== StatutDeclaration.NON_TELECHARGEE));
  const etablissementsWithValidDeclaration = etablissementsDeclarants.filter(({ statutDeclaration }) => (statutDeclaration === StatutDeclaration.DEPOSEE));

  const depotDeclarationDisabled = (statut === OrganismeStatutType.DEPOT_BLOQUE || etablissementsWithDownloadedDeclaration.length === 0);
  const depotAttestationDisabled = (statut === OrganismeStatutType.DEPOT_BLOQUE || etablissementsWithValidDeclaration.length === 0);


  return (
    <div className={'px-8 py-8'}>

      <h6>Dépôts</h6>

      <div className={'flex flex-col gap-8 items-center text-center'}>

        <div className={'font-bold'}>
          <span>{t['DEPOT_OFA_INFO_TEXT1']}</span> <br />
          <span className={'text-(--text-label-blue-france) '}>{campagneAnnee}</span>
        </div>

        {((etablissementsWithDownloadedDeclaration.length + etablissementsWithValidDeclaration.length) === 0)
          ? (
            <span className={'text-gray-400'}>{t['CAMPAGNE_DEPOT_MES1']}</span>
          )
          : (
            <div className={'flex flex-col gap-4'}>

              {/* Depot Declaration */}
              <Button onClick={() => depotDeclarationModal.open()} disabled={depotDeclarationDisabled}>
                <MdOutlineFileDownload className={'h-6 w-6 mr-2'} />
                Déposer une déclaration
              </Button>
              {!depotDeclarationDisabled && (
                <DepotDeclarationModal dsfrModal={depotDeclarationModal}
                                       etablissements={etablissementsWithDownloadedDeclaration} />
              )}

              {/* Depot Attestation */}
              <Button priority="secondary" onClick={() => depotAttestationModal.open()}
                      disabled={depotAttestationDisabled}>
                <MdOutlineFileDownload className={'h-6 w-6 mr-2'} />
                Déposer une attestation
              </Button>
              {!depotAttestationDisabled && (
                <DepotAttestationModal dsfrModal={depotAttestationModal}
                                       etablissements={etablissementsWithValidDeclaration} />
              )}
            </div>
          )}
      </div>
    </div>
  );
};

interface CampagneDepotsProps {
  campagneAnnee: number;
  organismeId: number;
}